<template>
  <div>
    <vgp-button
      :label="locales('upgrade_rate_btn')"
      :type="type"
      @onClick="upgradeClick"
    />
  </div>
</template>

<script>
import { getPlansObj } from '../../../../helpers/pricingHelper';
import plansModel from '../../../../models/plans';
import vgpButton from '../globalButton/vgpButton.vue';

export default {
  components: { vgpButton },
  props: {
    feature: { type: String, require: true, default: '' },
    type: { type: String, require: false, default: 'primary' },
  },
  data() {
    return {
      locales: __,
    };
  },
  methods: {
    upgradeClick() {
      const newPlanObj = getPlansObj(this.feature);
      const userPlan = plansModel.getPlanInfo();

      userExtAnalytics.log('pricing_deadlock_reached', { type: this.feature });
      this.$store.dispatch('globalPopup/show', {
        type: 'upgradePlan',
        title: 'upgrade_plan_popup_title',
        currentPlan: userPlan,
        newPlan: newPlanObj,
        // userCount: user.subscription.user_count,
        isAnnual: plansModel.isAnnual(),
      });
    },
  },
};
</script>

<style scoped src='./less/upgradeButton.less'></style>
